var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"settings-wrapper"},[_c('v-flex',{staticStyle:{"box-shadow":"0 3px 6px #0000000d"},attrs:{"xs12":"","sm12":""}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content"},[_vm._t("content")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }